import { Box, Flex, Text, Icon, Badge, IconButton } from "@chakra-ui/react";
import { FaEdit, FaExclamationTriangle, FaEye, FaEyeSlash } from "react-icons/fa";
import { memo } from "react";

const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${month}.${date.getFullYear()}`;
};

const EntryTable = ({ entries, onEdit, onDeactivate }) => {
    if (entries.length === 0) {
        return (
            <Text color="gray.500" fontSize="sm" textAlign="center" py={8}>
                Nema unosa. Dodajte prvi unos.
            </Text>
        );
    }

    return (
        <Box>
            {entries.map((entry, index) => (
                <Flex
                    key={entry.id}
                    justify="space-between"
                    align="center"
                    gap={3}
                    py={3}
                    borderBottom={index !== entries.length - 1 ? "1px solid" : "none"}
                    borderColor="gray.100"
                >
                    <Flex align="center" gap={3} minW={0}>
                        {entry.isProblem && (
                            <Flex
                                align="center"
                                justify="center"
                                boxSize="36px"
                                borderRadius="full"
                                bg="red.50"
                                flexShrink={0}
                            >
                                <Icon as={FaExclamationTriangle} color="red.500" boxSize={3.5} />
                            </Flex>
                        )}
                        <Box minW={0}>
                            <Text fontWeight="600" color={entry.isProblem ? "red.600" : "gray.800"} noOfLines={1}>
                                {entry.subjectName}
                            </Text>
                            <Flex align="center" gap={2} mt={0.5}>
                                <Text fontSize="sm" color={entry.isProblem ? "red.500" : "gray.500"} fontWeight={entry.isProblem ? "600" : "normal"}>
                                    Ističe {formatDate(entry.expirationDate)}
                                </Text>
                                {!entry.isActive && (
                                    <Badge colorScheme="red" fontSize="10px">Neaktivno</Badge>
                                )}
                            </Flex>
                        </Box>
                    </Flex>
                    <Flex gap={2} flexShrink={0}>
                        <IconButton
                            icon={<FaEdit />}
                            size="sm"
                            aria-label="Uredi unos"
                            onClick={() => onEdit("entry", entry)}
                        />
                        <IconButton
                            icon={entry.isActive ? <FaEyeSlash /> : <FaEye />}
                            size="sm"
                            aria-label={entry.isActive ? "Izbriši unos" : "Aktiviraj unos"}
                            onClick={() => onDeactivate("entry", entry)}
                        />
                    </Flex>
                </Flex>
            ))}
        </Box>
    );
};

export default memo(EntryTable);
